import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    list: [],
    selectList: []
};

const mutations = {
    'INICIALIZAR'(state) {
        state.list = [];
        state.selectList = [];
    },

    'CONDICIONESFISCALES'(state, condicionesFiscales) {
        state.condicionesFiscales = condicionesFiscales;
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(condicionFiscal => condicionFiscal.nombre.trim());
    },
};

const actions = {
    getCondicionesFiscales: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            apiAxios.get('condicionesfiscales/list')
                .then(res => {
                    commit('SET_LIST', res.data)
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
};

const getters = {
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}